const iconToMime: { [key: string]: string[] } = {
  'fa-file-image.svg': [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/svg+xml',
    'image/webp',
    'image/tiff',
  ],
  'fa-file-pdf.svg': ['application/pdf'],
  'fa-file-audio.svg': ['audio/mpeg', 'audio/ogg', 'audio/wav', 'audio/wma'],
  'fa-file-video.svg': [
    'video/mp4',
    'video/ogg',
    'video/webm',
    'video/x-msvideo',
    'video/mpeg',
  ],
  'fa-file-compressed.svg': [
    'application/zip',
    'application/x-7z-compressed',
    'application/vnd.rar',
    'application/x-tar',
  ],
  'fa-file-excel.svg': [
    'application/excel',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  'fa-file-document.svg': [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/rtf',
    'text/plain',
  ],
  'fa-file-presentation.svg': [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/mspowerpoint',
  ],
};

const mimeToIcon = Object.entries(iconToMime)
  .flatMap(([icon, mimeTypes]) => mimeTypes.map((mime) => [mime, icon]))
  .reduce<Record<string, string>>((acc, [mime, icon]) => {
    acc[mime] = icon;
    return acc;
  }, {});

export const getMimeTypeIcon = (
  mimeType: string | null | undefined
): string => {
  if (mimeType == null) {
    return 'fa-file-other.svg';
  }
  return mimeToIcon[mimeType] ?? 'fa-file-other.svg';
};

export const getMimeTypeIconUrl = (
  mimeType: string | null | undefined
): string => `assets/svg/mime/${getMimeTypeIcon(mimeType)}`;

export const isImage = (mimeType: string | null | undefined): boolean =>
  mimeType == null ? false : mimeToIcon[mimeType] === 'fa-file-image.svg';
